// extracted by mini-css-extract-plugin
module.exports = {"root":"about-me_root__3RWIk"};